// Browser interface to represent browser information
export interface Browser {
  name: string
  supported: boolean
  userAgent: string
}

// List of unsupported browsers with their detection patterns
const UNSUPPORTED_BROWSERS = [
  {
    name: 'LinkedIn',
    pattern: /linkedin/i,
  },
  // Can easily add more browsers in the future
  // { name: 'BrowserX', pattern: /browserx/i },
]

/**
 * Detects the current browser and returns browser information
 * @returns Browser object with support status and name
 */
export function getBrowser(): Browser {
  const userAgent = navigator.userAgent

  // Check against list of unsupported browsers
  for (const browser of UNSUPPORTED_BROWSERS) {
    if (browser.pattern.test(userAgent)) {
      return {
        name: browser.name,
        supported: false,
        userAgent,
      }
    }
  }

  // Default to a supported browser
  return {
    name: 'Default',
    supported: true,
    userAgent,
  }
}

export function getDomainFromUrl(url: string): string {
  try {
    const domain = new URL(url).hostname
    return domain.replace(/^www\./, '')
  } catch {
    return 'Web Content'
  }
}
